import React, { useContext } from 'react';
import { Row, Col, Typography, Button, Switch } from 'antd';
import { LoginOutlined, LockOutlined } from '@ant-design/icons';

import * as Config from '../../../Config';

const { Text, Title } = Typography;

const PremiumBanner = () => {
  return (
    <div>
      <Row align='middle' style={{ padding: '4rem', align: 'center' }}>
        <Col xs={24}>
          <Col align='center'>
            <Title style={{ fontSize: '44px', color: '#fff' }}>
              Mark your next step
            </Title>
            <Text style={{ fontSize: '20px', color: '#fff' }}>
              We designed and tested prototypes that helped identify pain points
              in the account creation process. Together, we shaped the new
              standard.
            </Text>
          </Col>
        </Col>
      </Row>
    </div>
  );
};

export default PremiumBanner;
